<div class="{{classes}}" [class.clickable]="canNavigateToVisualObject" (click)="onVisualObjectClick()">
  <ng-content></ng-content>
</div>
